import React from 'react';
import { X, Download } from 'lucide-react';

interface FilePreviewModalProps {
    isOpen: boolean;
    fileName: string;
    fileUrl: string | null;
    isPdf: boolean;
    onClose: () => void;
    onDownload: () => void;
}

const FilePreviewModal: React.FC<FilePreviewModalProps> = ({
    isOpen,
    fileName,
    fileUrl,
    isPdf,
    onClose,
    onDownload
}) => {
    if (!isOpen || !fileUrl) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/80"
                onClick={onClose}
            />

            {/* Modal */}
            <div className="relative bg-white rounded-xl shadow-xl w-full max-w-5xl max-h-[90vh] mx-4 flex flex-col">
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b border-gray-200 flex-shrink-0">
                    <h3 className="text-lg font-semibold text-gray-900 truncate pr-4">{fileName}</h3>
                    <div className="flex items-center gap-2">
                        <button
                            onClick={onDownload}
                            className="flex items-center gap-2 px-3 py-1.5 bg-amber-600 text-white rounded-lg text-sm hover:bg-amber-700 transition-colors"
                        >
                            <Download size={16} />
                            Download
                        </button>
                        <button
                            onClick={onClose}
                            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                        >
                            <X size={20} className="text-gray-500" />
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-auto p-4 min-h-0">
                    {isPdf ? (
                        <iframe
                            src={fileUrl}
                            className="w-full h-full min-h-[70vh] rounded-lg border border-gray-200"
                            title={fileName}
                        />
                    ) : (
                        <div className="flex items-center justify-center h-full min-h-[50vh]">
                            <img
                                src={fileUrl}
                                alt={fileName}
                                className="max-w-full max-h-[70vh] object-contain rounded-lg"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FilePreviewModal;
